module.exports = __webpack_public_path__ + "static/media/emergencias-login.24e4c48f.png";